import styled from 'styled-components';

export const Content = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  float: left;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border-bottom: 4px solid rgba(255, 255, 255, 0.2);

  header {
    width: 100%;
    float: left;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 20px;

    button {
      background: ${({ theme }) => theme.colors.LIGHT2};
      border-radius: 100%;
      padding: 5px;
    }
  }

  @media (max-width: 1024px) {
  }
`;

export const Client = styled.div`
  float: left;
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  text-align: center;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border-top: 2px solid rgba(255, 255, 255, 0.1);
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);

  > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin: 0 0 20px 0;

    i {
      float: left;
      margin: 0 20px 0 0;
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    > div {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      float: left;
      width: 30%;
    }

    span {
      font-size: 12px;
      color: ${({ theme }) => theme.colors.TEXT4};
      float: left;
      width: 100%;
      text-align: left;
    }

    strong {
      float: left;
      width: 100%;
      text-align: left;
      font-size: 14px;
      color: ${({ theme }) => theme.colors.TEXT1};
      font-weight: 700;
      width: 100%;
      margin-bottom: 10px;
    }

    button {
      background: none;
      width: 30px;
      height: 30px;
      opacity: 0;
      transition: all 0.5s ease;

      &:hover {
        opacity: 0.5;
      }
    }

    &:hover {
      button {
        opacity: 1;
      }
    }
  }

  @media (max-width: 1024px) {
    padding: 10px;

    div {
      i {
        margin: 0px 10px 0 0;
        height: 25px;
        width: 20px;
      }

      span {
        font-size: 10px;
      }

      strong {
        font-size: 10px;
      }
    }
  }
`;

export const Summary = styled.div`
  float: left;
  width: 100%;
  padding: 0;
  display: flex;
  flex-direction: column;
  text-align: center;
  background: ${({ theme }) => theme.colors.LIGHT1};
  border-top: 2px solid rgba(255, 255, 255, 0.1);

  div {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;

    i {
      height: 25px;
      width: 2px;
      background: ${({ theme }) => theme.colors.LIGHT1};
      float: left;
      margin: 0 20px;
    }

    span {
      font-size: 12px;
      color: ${({ theme }) => theme.colors.TEXT4};
      text-align: right;
      font-weight: 700;
    }

    strong {
      text-align: left;
      font-size: 12px;
      color: ${({ theme }) => theme.colors.TEXT1};
      font-weight: 700;
      width: 200px;
    }

    &.total {
      i {
        height: 50px;
      }

      span {
        color: ${({ theme }) => theme.colors.TEXT1};
        font-size: 14px;
      }
      strong {
        font-size: 14px;
        color: #ff8904;
      }
    }
  }

  ins {
    width: 100%;
    float: left;
    height: 2px;
    background: ${({ theme }) => theme.colors.LIGHT1};
  }

  @media (max-width: 1024px) {
    width: 100%;
    padding: 0 10px;

    ins {
      margin: 0 0 20px 0;
    }

    div {
      justify-content: flex-start;
      align-items: flex-start;
      width: 100%;
      float: left;

      span {
        font-size: 10px;
        width: auto;
      }

      i {
        margin: 0px 5px;
        background: none;
      }

      strong {
        font-size: 10px;
        width: auto;
      }
    }
  }
`;

export const Align = styled.div`
  float: left;
  display: flex;
  align-items: center;
  height: 60px;
`;

export const Thumb = styled.div`
  float: left;
  width: 60px;
  overflow: hidden;
  border-radius: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  background: ${({ theme }) => theme.colors.LIGHT1};
  
  img {
    max-width: 90px;
    max-height: 90px;
    float: left;
    min-width: 60px;
    min-height: 60px;
  }
`;
